import { cn } from "@lib/utils";

/** Renders an accessible label associated with controls.
 * @prop className - The class name to apply to the label.
 * @prop ...props - The props to apply to the label.
 */
export const Label = ({ className, ...props }: React.ComponentProps<"label">) => (
	<label
		data-slot="label"
		className={cn(
			`flex cursor-pointer items-center gap-2 text-sm leading-none font-medium select-none
			group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50
			peer-disabled:cursor-not-allowed peer-disabled:opacity-50`,
			className,
		)}
		{...props}
	/>
);

Label.displayName = "Label";
